import classNames from "classnames";
import { useCallback } from "react";
import { IAvisEditableListFieldConfig, IEditableListRowState } from "../types";
import { AvisFieldValueView } from "./renderers/AvisFieldValueView";

interface IAvisEditableListRowFieldProps<P extends IEditableListRowState> {
  prefix: string;
  rowIndex: number;
  value: P;
  errors: any;
  classNameField?: string;
  field: IAvisEditableListFieldConfig<P>;
  onChange: (e: any) => void;
}

export function AvisEditableListRowField<P extends IEditableListRowState>(
  props: Readonly<IAvisEditableListRowFieldProps<P>>,
) {
  const { prefix, rowIndex, value, errors, classNameField, field, onChange } =
    props;

  const classGridField = classNames(
    "avis-editable-list-row-cell",
    classNameField,
  );

  //Esošā situācija ka faila lauks satur 2 key fileName un base64Data ir specifisks
  //Papildināts specgadījums apstrādāt lauku "base64Data", lai iezīmētu tukša faila gadījumā kļūdas klasi
  //Specifisks gadījums tieši pie jauna darba izveidē - failu pievienošanai

  const hasErrors =
    errors?.[rowIndex]?.[field.name] ||
    (field.name == "fileName" && errors?.[rowIndex]?.["base64Data"]);

  const classNameFieldWError = classNames(
    classGridField,
    hasErrors ? "avis-input-error" : "",
  );

  const renderField = useCallback(() => {
    const viewMode =
      (!value?.rowState ||
        value?.rowState === "View" ||
        value?.rowState === "Delete") &&
      !field.forceEditMode;

    if (viewMode || field.forceViewMode) {
      return (
        <div className="cell-value view-mode">
          <AvisFieldValueView
            field={field}
            value={(value as any)[field.name.toString()]}
            rowValue={value}
            rowState={value?.rowState}
          />
        </div>
      );
    } else {
      return (
        <div className="cell-value edit-mode">
          {field.renderField?.(field, prefix, rowIndex, value, onChange)}
        </div>
      );
    }
  }, [field, onChange, prefix, rowIndex, value]);

  return <div className={classNameFieldWError}>{renderField()}</div>;
}
